/** "wdjb mjht", "WDJBMJHT" or "wdjb-mjht" → "WDJB-MJHT"; anything else → null. */
export function normalizeUserCode(input: string | null | undefined): string | null {
  const letters = (input ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  return letters.length === 8 ? `${letters.slice(0, 4)}-${letters.slice(4)}` : null;
}
